import React              from "react";
import PropTypes          from "prop-types";
import CategoriesTile     from "../Grid2/Tiles/CategoriesTile";
import CategoriesListTile from "../Grid2/Tiles/CategoriesListTile";
import Grid2              from "../Grid2/Grid2";
import withCategories     from "../HigherOrderComponents/Categories/withCategories";
import withStaticLoader   from "../HigherOrderComponents/Utility/withStaticLoader";

class CategoriesOverviewGrid extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		if (!this.props.data || this.props.data.length === 0) {
			return null;
		}

		const tileClass = this.props.isListMode ? CategoriesListTile : CategoriesTile;
		const columns   = this.props.columns ? this.props.columns : (this.props.isListMode ? {xs: 1} : {xs: 2, md: 4});

		return (
			<Grid2 tileData={this.props.displayCount ? this.props.data.slice(0, this.props.displayCount) : this.props.data}
			       defaultTileClass={tileClass}
			       columns={columns}
			       defaultTileConfig={{footer: {}, badges: {textBadges: {show: {price: false}}}}}
			       noContainerMargins={this.props.isListMode}
			       headlineType={this.props.headlineType}
			/>
		);
	}
}

CategoriesOverviewGrid.propTypes = {
	data:         PropTypes.array.isRequired,
	isMobile:     PropTypes.bool,
	isListMode:   PropTypes.bool,
	headlineType: PropTypes.string,
	displayCount: PropTypes.number,
	columns:      PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.shape({
			xs: PropTypes.number.isRequired,
			sm: PropTypes.number,
			md: PropTypes.number,
			lg: PropTypes.number,
			xl: PropTypes.number,
		}),
	]),
};

CategoriesOverviewGrid.defaultProps = {
	isMobile:   false,
	isListMode: false,
};


export default withCategories(withStaticLoader(CategoriesOverviewGrid));
